import Vue from "vue";
import BootstrapVue from "bootstrap-vue";

// Include bootstrap vue
Vue.use(BootstrapVue);

export default BootstrapVue;
